<template>
  <div>
    <div class="page-operate-block">
      <div class="tit">字典列表</div>
      <div>
        <el-button v-permission="'add'" class="operate-btn" name="create" data-toggle="modal" @click="handleCreate">新增</el-button>
        <el-button v-permission="'update'" class="operate-btn" :disabled="options.selection.length != 1" @click="handleEditRow">编辑</el-button>
        <el-button v-permission="'delete'" class="operate-btn" :disabled="options.selection.length === 0" @click="handleDeleteRow">删除</el-button>
      </div>
    </div>

    <div class="table-list-block">
      <r-table
        :ref="tableVarity"
        :dataSource="tableData"
        :options="options"
        :pagination="pagination"
        @current-change="handlePageChange"
        @row-click="handleRowClick"
      >
        <el-table-column prop="typeName" label="类型" header-align="center" align="center">
          <template #header>
            <el-select clearable v-model="filters.search.type" filterable placeholder="类型" @change="handleSearch">
              <el-option v-for="item in dataTypesArr" :key="item.value" :label="item.text" :value="item.value">
              </el-option>
            </el-select>
          </template>
          <template #default="scope">
            <a @click.stop="handleDetail(scope.row)">{{ scope.row.typeName }}</a>
          </template>
        </el-table-column>
        <el-table-column label="字典编码" prop="name" header-align="center" align="center">
          <template #header>
            <el-input placeholder="字典编码" v-model="filters.search.name" @change="handleSearch"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="字典值" prop="value" show-overflow-tooltip header-align="center" align="center">
          <template #header>
            <el-input placeholder="字典值" v-model="filters.search.value" @change="handleSearch"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="说明" prop="description" show-overflow-tooltip header-align="center" align="center"></el-table-column>
        <el-table-column label="更新时间" prop="updateTimeStr" show-overflow-tooltip header-align="center" align="center"></el-table-column>
      </r-table>
    </div>
    <RModal
      customClass="manager-modal bigModalDialog"
      :title="modelTitle"
      top="5vh"
      :show="modalShow"
      :closeOnClick="false"
      width="800px"
      @change="modalShow = false"
      @close="modalShow = false"
    >
      <template #content>
        <dictBasicalForm
          :formType="clickModalType"
          :dict="selectDict"
          :modalShow="modalShow"
          @success="submitSuccess"
          @close="modalShow = false"
          :dataTypesArr="dataTypesArr"
        ></dictBasicalForm>
      </template>
    </RModal>
  </div>
</template>
<script>
import mixin from '@/components/common/tableMixin'
import RModal from "@/components/common/RModal";
import RTable from '@/components/common/RTable'
import tableMix from '@/components/common/tableListMixin.js'
import checkMix from '@/components/common/checkAll.js'
import moment from 'moment'
import dictBasicalForm from './dictBasicalForm'
import { mapGetters } from 'vuex'

import dictCommonMixin from './common'

export default {
  name: 'dictBasical',
  mixins: [mixin, tableMix, checkMix, dictCommonMixin],
  props: ['height'],
  components: {
    dictBasicalForm, RTable, RModal
  },
  data() {
    return {
      tableVarity: 'system-dict-basic-table',
      options: {
        multiSelect: true, // 多选
        serialNum: false, // 显示序号
        loading: false, // 加载中状态
        initTable: true, // 是否一挂载就加载数据
        mutiSelect: true,
        selection: [],
      },
      filters: {
        search: { name: '', value: '', type: '' },
      },
      pagination: {
        total: 0,
        pageIndex: 1,
        pageSize: 20
      },

      clickModalType: '新增',
      modalShow: false,
      types: '',
      selectDict: null,
      tableData: [],
      toExcel: false,
      modelTitle: '', // 弹窗标题

      dataTypesArr: []
    }
  },
  computed: {
    ...mapGetters(['dataTypes']),
  },
  created() {
    let params = {
      pageNumber: 1,
      pageSize: this.pagination.pageSize,
    }
    this.getTypeList()
    this._fetch(params)
  },

  methods: {
    handleSearch() {
      this.pagination.pageIndex = 1
      this._reloadData()
    },
    // 获取字典类型下拉
    getTypeList() {
      let url = 'SYSTEM.DICT.GET_TYPE_LIST'
      this.fetchData({ url, method: 'get' }).then(res => {
        res = res || []
        this.dataTypesArr = res.map(item => {
          item.text = item.typeName
          item.value = item.type
          return item
        })
      })
    },
    _fetch(params) {
      this._requestData()
      let url = 'SYSTEM.DICT.GET_LIST'
      this.fetchData({ url, method: 'get', params })
        .then((res) => {

          this._receiveData()
          if (this.toExcel) {
            this.toExcel = false
            window.location.href = res.data
            return
          }
          this.pagination.total = res && res.count
          this.tableData = this._getter(res.data) || []
        })
        .catch((err) => {
          this.toExcel = false
          this._receiveData()
          this.error = err
        })
    },
    _getter(items) {
      return items.map((data, index) => {
        data['typeText'] = this.dataTypes[data['type']]?this.dataTypes[data['type']]:data['type']
        data['updateTimeStr'] = moment(data['updateTime']).format('YYYY-MM-DD HH:mm:ss')
        Object.keys(data).forEach((key) => {
          if (data[key] === null) {
            data[key] = ''
          }
        })
        return data
      })
    },
    _reloadData() {
      let params = {
        ...this.filters.search,
        pageNumber: this.pagination.pageIndex,
        pageSize: this.pagination.pageSize,
      }
      //强制请求数据
      this.refreshData()
      this._fetch(params)
    },
    // 分页
    handlePageChange(val, ops) {
      this.pagination.pageIndex = val
      this.pagination.pageSize = ops
      this._reloadData()
    },
    changeModelTitle(types = '', preTitle) {
      if (types) {
        for (let i in this.dataTypesArr) {
          let obj = this.dataTypesArr[i]
          if (obj.value === types) {
            this.modelTitle = `${preTitle}: ${obj.text}`
            return
          }
        }
      } else {
        this.modelTitle = '编辑'
      }
    },
    handleCreate() {
      this.clickModalType = '新增'
      this.modelTitle = '新增'
      this.selectDict = { type: this.filters.search.type }
      this.modalShow = true
    },
    handleDetail(row) {
      this.clickModalType = '详情'
      this.modelTitle = '详情'
      this.selectDict = row
      this.modalShow = true
    },
    handleEditRow(row) {
      if (this.options.selection.length === 1) {
        this.handleEdit(this.options.selection[0])
      } else {
        this.$message.error('仅支持单条数据编辑！')
      }
    },
    handleEdit(row) {
      this.clickModalType = '编辑'
      this.modelTitle = '编辑'
      this.selectDict = row
      this.modalShow = true
    },
    submitSuccess() {
      this.submitFilter()
      this.modalShow = false
    },
    handleDeleteRow() {
      this.$confirm('确定删除当前选中的（' + this.options.selection.length + '条记录）信息吗？', { type: 'warning' })
        .then(() => {
          this.handleDelete(this.options.selection)
        })
        .catch(() => false)
    },
    handleDelete(rows) {
      let url = 'SYSTEM.DICT.POST_DELETE'
      let params = rows.map(item => item.id)
      this.fetchData({ url, method: 'post', params, flag: true, headers: { 'Content-Type': 'application/json' } })
        .then((res) => {
          if (res.code == 200) {
            this.$message.success('删除成功！')
            this._reloadData()
          } else {
            this.$message.error('删除失败！')
          }
        })
        .catch((err) => {
          this.$message.error(err)
        })
      $('body').trigger('click')
    },
    handleExport() {
      this.toExcel = true
      this._reloadData()
    },
  },
}
</script>
<style lang="less" scoped>
.el-popover__title {
  font-size: 14px;
}
.splitline {
  color: @font-darkblue-color-theme;
}
.theme-darkblue .m-r-xs:last-of-type {
  margin-right: 15px !important;
}
</style>
